<template>
  <div class="error-page">
    <Result
      :src="require('@/assets/404.png')"
      :text="$t('message_404')"
    >
      <md-button slot="button" type="primary">{{ $t('activate_wallet') }}</md-button>
    </Result>
  </div>
</template>

<script>
import Result from '@/components/Result'
import { Button } from 'mand-mobile'

export default {
  name: '404',

  components: {
    Result,
    [Button.name]: Button
  }
}
</script>

<style scoped>
.error-page {
  padding: 246px 40px;
}
</style>
